import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_Paging_PeriodLimitation_Api = async (params) => {
    const { data } = await request.post(
        `/PeriodLimitation/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_PeriodLimitation_Api = async (params) => {
    const { data } = await request.post(
        `/PeriodLimitation/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_PeriodLimitation_Api = async (id) => {
    const { data } = await request.get(
        `/PeriodLimitation/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_PeriodLimitation_Api = async (params) => {
    const { data } = await request.post(
        `/PeriodLimitation/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_PeriodLimitation_Api = async (id) => {
    const { data } = await request.delete(
        `/PeriodLimitation/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
